import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Playlist.svg",
  "use": "Playlist.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Playlist.svg\"><path d=\"M14.4195,42.5122l4.0762-1.0189a2,2,0,0,0,1.5147-1.94V14.0208a2,2,0,0,1,4,0V47.57c0,3.7845-3.3954,6.4511-8,6.4511a5.881,5.881,0,0,1-6-5.8615A5.8211,5.8211,0,0,1,14.4195,42.5122ZM30.01,16.0209h20a2,2,0,1,1,0,4h-20a2,2,0,1,1,0-4Zm0,14h20a2,2,0,1,1,0,4h-20a2,2,0,1,1,0-4Zm0,14h20a2,2,0,1,1,0,4h-20a2,2,0,1,1,0-4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol